/* eslint-disable no-shadow */
import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { proceedToNextFormStep } from "../../../actions/portalAgencySignUpActions";
import {
  StepWrapper,
  Title,
  Paragraph,
  Button,
} from "../styles/portal-agency-sign-up-styles";

interface Props {
  proceedToNextFormStep: () => void;
}

export const Description: FunctionComponent<Props> = ({
  proceedToNextFormStep,
}) => (
  <StepWrapper data-test-id="description-step" description>
    <Title data-test-id="title">Get started with Portal</Title>
    <Paragraph data-test-id="paragraph" first>
      Portal’s been designed to make your life easier, while helping employers
      that value recruiters and the relationship you’ve worked hard to develop
      in becoming a preferred supplier.
    </Paragraph>
    <Paragraph>
      You won your PSL status based on performance and trust. Portal will
      showcase these qualities, allowing you to further cement your status as a
      integral part of your client’s people strategy.
    </Paragraph>
    <Paragraph last>
      We’re looking forward to meeting you and getting you setup.
      <br />
      Click <i>Next</i> to continue.
    </Paragraph>
    <Button
      type="button"
      onClick={() => proceedToNextFormStep()}
      data-test-id="next-button"
    >
      Next
    </Button>
  </StepWrapper>
);

Description.propTypes = {
  proceedToNextFormStep: PropTypes.func.isRequired,
};

export default connect(null, { proceedToNextFormStep })(Description);
